import { render, staticRenderFns } from "./UploadShipmentsModal.vue?vue&type=template&id=a9a5ac44"
import script from "./UploadShipmentsModal.vue?vue&type=script&lang=js"
export * from "./UploadShipmentsModal.vue?vue&type=script&lang=js"
import style0 from "./UploadShipmentsModal.vue?vue&type=style&index=0&id=a9a5ac44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports